//@ts-check
import request from '../request';
/**
 * Get the file info
 * @param {string} workspace
 * @param {string} path
 */

export var getFile = function getFile(workspace, path) {
  return request({
    url: '/backend/files',
    query: {
      workspace: workspace,
      filePath: path
    }
  });
};
/**
 * Save the content of a file
 * @param {string} workspace
 * @param {string} path
 */

export var saveFile = function saveFile(workspace, path, content) {
  return request({
    url: '/backend/files',
    query: {
      workspace: workspace,
      filePath: path
    },
    method: 'POST',
    contentType: 'json',
    data: JSON.stringify(content)
  });
};
/**
 * Get resource token associated with this file
 * @param {string} workspace
 * @param {string} filePath
 * @returns {Promise<string>}
 */

export var getResourceToken = function getResourceToken(workspace, filePath) {
  return request({
    url: '/backend/fileresourcetoken',
    query: {
      workspace: workspace,
      filePath: filePath
    }
  });
};
/**
 * Get resource token associated with a windows local file from engage
 * @param {string} filePath
 * @returns {Promise<string>}
 */

export var getLocalFileResourceToken = function getLocalFileResourceToken(filePath) {
  return request({
    url: '/backend/localfileresourcetoken',
    query: {
      filePath: filePath
    }
  });
};
export default {
  getFile: getFile,
  saveFile: saveFile,
  getResourceToken: getResourceToken,
  getLocalFileResourceToken: getLocalFileResourceToken
};